import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './About.css';
import card6 from '../../images/cards/CYBERLINGO-Easy-37.jpg';
import card7 from '../../images/cards/CYBERLINGO-Advanced-25.jpg'

const About = () => {
  const [isFlipped, setIsFlipped] = useState(false);
  const [isAutoFlipping, setIsAutoFlipping] = useState(true);

  // Auto-flip effect
  useEffect(() => {
    if (isAutoFlipping) {
      const interval = setInterval(() => {
        setIsFlipped(prev => !prev);
      }, 4000); // Flip every 4 seconds

      return () => clearInterval(interval);
    }
  }, [isAutoFlipping]);

  // Card images for front and back
  const cardFront = card6;
  
  const cardBack = card7;

  const handleCardClick = () => {
    setIsFlipped(!isFlipped);
    setIsAutoFlipping(false);
    // Resume auto-flipping after 10 seconds of inactivity
    setTimeout(() => setIsAutoFlipping(true), 10000);
  };

  return (
    <section className="about" id="about" data-aos="fade-up">
      <div className="container">
        <div className="about__grid">
          <div className="about__content" data-aos="fade-right" data-aos-delay="200">
            <h2 className="about__title">About the Game</h2>
            <p className="about__text">
              CyberLingo was created to make cybersecurity simple, social, and unforgettable. It's a first-of-its-kind card game that breaks down complex cybersecurity concepts into fun, relatable, and interactive gameplay.
            </p>
            <p className="about__text">
              Players learn to identify phishing, manage passwords, spot social engineering tactics, and defend against digital attacks—all through laughter, strategy, and teamwork.
              Whether you're a beginner, a professional, or part of a corporate training session, CyberLingo helps bridge the gap between learning and doing.
            </p>
            <div className="about__features" data-aos="fade-up" data-aos-delay="400">
              <div className="about__feature">
                <span className="material-icons about__feature-icon">groups</span>
                <span>4+ Players</span>
              </div>
              <div className="about__feature">
                <span className="material-icons about__feature-icon">schedule</span>
                <span>2+ Groups</span>
              </div>
              <div className="about__feature">
                <span className="material-icons about__feature-icon">cake</span>
                <span>Ages 10+</span>
              </div>
            </div>
          </div>
          
          <div className="about__card-container" data-aos="fade-left" data-aos-delay="400">
            <motion.div 
              className="about__card-wrapper"
              animate={{
                scale: [1, 1.15, 1],
                z: [0, 50, 0]
              }}
              transition={{
                duration: 2,
                repeat: Infinity,
                ease: "easeInOut",
                type: "tween"
              }}
              onMouseEnter={() => setIsAutoFlipping(false)}
              onMouseLeave={() => setIsAutoFlipping(true)}
              onClick={handleCardClick}
            >
              <motion.div
                className="about__card-3d"
                animate={{
                  rotateY: isFlipped ? 180 : 0,
                }}
                transition={{
                  duration: 0.8,
                  type: "spring",
                  stiffness: 100,
                  damping: 20
                }}
                style={{
                  transformStyle: "preserve-3d",
                  cursor: "pointer"
                }}
              >
                {/* Front of card */}
                <motion.div 
                  className="about__card-face about__card-face--front"
                  style={{
                    backfaceVisibility: "hidden",
                    position: "absolute",
                    width: "100%",
                    height: "100%"
                  }}
                >
                  <img 
                    src={cardFront}
                    alt="CyberLingo card front" 
                    className="about__card-image"
                  />
                  <div className="about__card-shine" />
                  {/* <div className="about__card-label about__card-label--front">
                    <span>Attack Card</span>
                  </div> */}
                </motion.div>

                {/* Back of card */}
                <motion.div 
                  className="about__card-face about__card-face--back"
                  style={{
                    backfaceVisibility: "hidden",
                    transform: "rotateY(180deg)",
                    position: "absolute",
                    width: "100%",
                    height: "100%"
                  }}
                >
                  <img 
                    src={cardBack}
                    alt="CyberLingo card back" 
                    className="about__card-image"
                  />
                  <div className="about__card-shine" />
                  {/* <div className="about__card-label about__card-label--back">
                    <span>Defense Card</span>
                  </div> */}
                </motion.div>
              </motion.div>

              {/* Floating particles around card */}
              <div className="about__card-particles">
                {[...Array(4)].map((_, i) => (
                  <motion.div
                    key={i}
                    className="about__card-particle"
                    animate={{
                      y: [0, -30, 0],
                      x: [0, i % 2 === 0 ? 15 : -15, 0],
                      opacity: [0, 1, 0],
                    }}
                    transition={{
                      duration: 3,
                      repeat: Infinity,
                      delay: i * 0.7,
                      ease: "easeOut"
                    }}
                  />
                ))}
              </div>
            </motion.div>

            {/* Click instruction */}
            <br />
            <motion.p 
              className="about__card-hint"
              animate={{
                opacity: [0.5, 1, 0.5]
              }}
              transition={{
                duration: 2,
                repeat: Infinity,
                ease: "easeInOut"
              }}
            >
              Click to flip the card
            </motion.p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;